import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { POST } from 'shared/api/POST'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Town = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [town, setTown] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setTown(branchList?.find(branch => branch.Intern === branchId)?.Town || '')
    }
  }, [branchList?.length, branchId])

  const updateTown = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.Town !== town) {
      updateBranch({ Town: town })
    }
  }

  return <Input label='Town' onChange={setTown} onBlur={updateTown} value={town} />
}
